<template>
    <div class="loginContent">
        <div class="webName">{{ webData.sitename }}</div>
        <div class="loginFlex flex">
            <el-image :src="require('@/assets/image/loginBg.png')" fit="cover" class="loginBg"></el-image>
            <div class="loginBox column">
                <div class="tabsBox" v-if="loginType">
                    <el-tabs v-model="activeName">
                        <el-tab-pane label="微信扫码登录" name="first">
                            <el-image :src="webData.qrcode" fit="cover" class="loginCode">
                                <div slot="error" class="imgSlot center">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>
                            <div class="loginCodeTips">微信扫码关注公众号注册/登录</div>
                        </el-tab-pane>
                        <el-tab-pane label="账号密码登录" name="second">
                            <div class="iptBox align" style="margin-top: 45px;">
                                <el-image :src="require('@/assets/icon/loginIcon01.png')" fit="cover" class="loginIcon"></el-image>
                                <div class="iptLine"></div>
                                <el-input placeholder="请输入手机号" v-model="phone" maxlength="11" class="loginIpt"></el-input>
                            </div>
                            <div class="iptBox align" style="margin-top: 20px;">
                                <el-image :src="require('@/assets/icon/loginIcon02.png')" fit="cover" class="loginIcon"></el-image>
                                <div class="iptLine"></div>
                                <el-input placeholder="请输入密码" v-model="pass" class="loginIpt"></el-input>
                            </div>
                            <div class="loginBtn" @click="loginBtnTap">登录</div>
                            <div class="spb" style="width: 328px;">
                                <div class="iptTips">新用户注册请先用扫码登录</div>
                                <div class="forget" @click="loginType = fasle">忘记密码？</div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                    <div class="welcomeBox center">
                        <div class="welcomeL"></div>
                        <div class="welcome">欢迎登录全域赚钱联盟系统</div>
                        <div class="welcomeR"></div>
                    </div>
                </div>
                <div class="tabsBox" v-else>
                    <el-image :src="require('@/assets/icon/close.png')" fit="cover" class="loginClose" @click="loginType = true"></el-image>
                    <div class="resetting">重置密码</div>
                    <div class="iptBox align" style="margin-top: 40px;">
                        <el-image :src="require('@/assets/icon/loginIcon01.png')" fit="cover" class="loginIcon"></el-image>
                        <div class="iptLine"></div>
                        <el-input placeholder="请输入手机号" v-model="phone" maxlength="11" class="loginIpt"></el-input>
                    </div>
                    <div class="iptBox align">
                        <el-image :src="require('@/assets/icon/loginIcon03.png')" fit="cover" class="loginIcon"></el-image>
                        <div class="iptLine"></div>
                        <el-input placeholder="请输入验证码" v-model="code" class="loginIpt"></el-input>
                        <div :class="['codeBtn',!gain ? 'codeBtnNo' : '']" @click="codeBtnTap">{{ time == '0' ? '发送验证码' : time + 's后重新获取' }}</div>
                    </div>
                    <div class="iptBox align" style="margin-top: 32px;">
                        <el-image :src="require('@/assets/icon/loginIcon02.png')" fit="cover" class="loginIcon"></el-image>
                        <div class="iptLine"></div>
                        <el-input placeholder="请输入新密码" v-model="pass" class="loginIpt"></el-input>
                    </div>
                    <div class="iptBox align">
                        <el-image :src="require('@/assets/icon/loginIcon02.png')" fit="cover" class="loginIcon"></el-image>
                        <div class="iptLine"></div>
                        <el-input placeholder="再次确认新密码" v-model="pass" class="loginIpt"></el-input>
                    </div>
                    <div class="loginBtn" @click="loginBtnTap">确定</div>
                    <div class="spb" style="width: 328px;">
                        <div class="iptTips">新用户注册请先用扫码登录</div>
                        <div class="forget" @click="loginType = true">去登录</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return{
                loginType: true,
                activeName: 'first',
                LoginTime: '',
                phone: '',
                code: '',
                pass: '',
                gain: true,
                time: 0,
                webData: {}
            }
        },
        beforeDestroy(){
            clearInterval(this.LoginTime)
        },
        mounted(){
            this.getIndexCategory()
            console.log(this.$route.query.router == undefined)
        },
        methods: {
             // 获取网站名称/二维码
             getIndexCategory(){
                this.request.get("api/user/pclogin",{
                    params:{
                       
                    }
                })
                .then(res=>{
                    this.webData = res.data
                    this.getLoginType()
                })
            },
            // 获取扫码结果
            getLoginType(){
                this.LoginTime = window.setInterval(() => {
                    this.request.get("api/user/getpcloginstatus",{
                        params:{
                            str: this.webData.str
                        }
                    })
                    .then(res=>{
                        if(res.code){
                            clearInterval(this.LoginTime)
                            localStorage.setItem('userId',res.data)
                            this.$message({
                                message: '登录成功',
                                type: 'success'
                            });
                            if(this.$route.query.router == undefined){
                                this.$router.go(-1)
                            }else{
                                this.$router.replace({ name: this.$route.query.router })
                            }
                        }
                    })
                    .catch(err=>{
                        clearInterval(this.LoginTime)
                    })
                }, 1000);
            },
            // 获取验证码
            codeBtnTap(){
                var that = this
                if(that.gain && that.phoneBlur() == ''){
                    this.request.get("api/common/sendSms",{
                        params:{
                            mobile: that.phone,
                            timeStamp: parseInt(new Date().getTime() / 1000)
                        }
                    })
                    .then(res=>{
                        if(res.code){
                            that.time = 60
                            that.gain = false
                            var count = setInterval(function(){
                                that.time--
                                if(that.time == 0){
                                    that.gain = true
                                    clearInterval(count)
                                }
                            },1000)
                        }else{
                            that.$message.error(res.msg);
                        }
                        
                    })
                }
            },
            // 登录
            loginBtnTap(){
                if(this.active == '0' && this.phoneBlur() == '' && this.codeBlur() == ''){
                    this.request.get("index/user/login",{
                        params:{
                            mobile: this.phone,
                            code: this.code
                        }
                    })
                    .then(res=>{
                        if(res.code){
                            localStorage.setItem('userInfo',JSON.stringify(res.data))
                            this.$message({
                                message: '登录成功',
                                type: 'success'
                            });
                            setTimeout(()=>{
                                this.$router.go(-1)
                            },1000)
                        }else{
                            this.$message.error(res.msg);
                        }
                    })
                }
                if(this.active == '1' && this.phoneBlur() == '' && this.passBlur() == ''){
                    this.request.get("index/user/login",{
                        params:{
                            mobile: this.phone,
                            password: this.pass
                        }
                    })
                    .then(res=>{
                        if(res.code){
                            localStorage.setItem('userInfo',JSON.stringify(res.data))
                            this.$message({
                                message: '登录成功',
                                type: 'success'
                            });
                            setTimeout(()=>{
                                this.$router.go(-1)
                            },1000)
                        }else{
                            this.$message.error(res.msg);
                        }
                    })
                }
            },
        }
    }
</script>
<style lang="less" scoped>
    @import '../../common/css/login.less';
</style>